import { reactive } from "vue";
import LayoutFooterApp from "../layout/footer/FooterApp.vue";
import { createLayoutApp } from "../layout/createLayoutApp";
import { getLayoutModel, pickLayoutProps } from "../layout/layoutModel";
import { ensureTourOperatorOfficeContactsBindings } from "../layout/tourOperatorOfficeContactsLoader";

const mountEl = document.getElementById("site-footer");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  const layoutModel = getLayoutModel() ?? {};
  const sharedModel = window.layoutModel ?? reactive(layoutModel);
  const { updateTourOperatorOfficeContacts, ensureTourOperatorOfficeContacts } =
    ensureTourOperatorOfficeContactsBindings(sharedModel);
  window.layoutModel = sharedModel;
  const props = pickLayoutProps(sharedModel, [
    "footerMenu",
    "footerCmsResources",
    "currencyRateInfo",
    "tourOperatorOfficeContacts",
    "updateTourOperatorOfficeContactsFn",
    "ensureTourOperatorOfficeContactsFn",
    "convertedAllToCurrency",
  ]);
  props.updateTourOperatorOfficeContactsFn = updateTourOperatorOfficeContacts;
  props.ensureTourOperatorOfficeContactsFn = ensureTourOperatorOfficeContacts;
  const app = createLayoutApp(LayoutFooterApp, props);
  const root = document.createElement("div");
  mountEl.replaceWith(root);
  app.mount(root);
}
